// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    min-height: 100vh;
    background: #f5f5f5;
}

.dashboard-header {
    background: white;
    padding: 20px 40px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dashboard-header h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
}

.user-info {
    margin: 5px 0 0 0;
    color: #666;
    font-size: 14px;
}

.badge {
    display: inline-block;
    padding: 2px 8px;
    background: #667eea;
    color: white;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-left: 0 !important;
    text-transform: uppercase;
}

.header-actions {
    display: flex;
    gap: 10px;
    align-items: center;
}

.logout-btn {
    padding: 8px 20px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
}

.logout-btn:hover {
    background: #c82333;
}

.dashboard-nav {
    background: white;
    border-bottom: 2px solid #eee;
    padding: 0 40px;
    display: flex;
    gap: 5px;
}

.nav-btn {
    padding: 15px 25px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    transition: all 0.2s;
}

.nav-btn:hover {
    color: #333;
    background: #f8f9fa;
}

.nav-btn.active {
    color: #667eea;
    border-bottom-color: #667eea;
}

.dashboard-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

.dashboard-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.dashboard-actions h2 {
    margin: 0;
    color: #333;
}

.primary-btn {
    padding: 10px 20px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: auto;
}

.primary-btn:hover {
    background: #5568d3;
}

.error {
    background: #fee;
    color: #c33;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.loading {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB","sourcesContent":[".dashboard {\n    min-height: 100vh;\n    background: #f5f5f5;\n}\n\n.dashboard-header {\n    background: white;\n    padding: 20px 40px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dashboard-header h1 {\n    margin: 0;\n    color: #333;\n    font-size: 24px;\n}\n\n.user-info {\n    margin: 5px 0 0 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.badge {\n    display: inline-block;\n    padding: 2px 8px;\n    background: #667eea;\n    color: white;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    margin-left: 0 !important;\n    text-transform: uppercase;\n}\n\n.header-actions {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.logout-btn {\n    padding: 8px 20px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: auto;\n}\n\n.logout-btn:hover {\n    background: #c82333;\n}\n\n.dashboard-nav {\n    background: white;\n    border-bottom: 2px solid #eee;\n    padding: 0 40px;\n    display: flex;\n    gap: 5px;\n}\n\n.nav-btn {\n    padding: 15px 25px;\n    background: transparent;\n    border: none;\n    border-bottom: 3px solid transparent;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #666;\n    transition: all 0.2s;\n}\n\n.nav-btn:hover {\n    color: #333;\n    background: #f8f9fa;\n}\n\n.nav-btn.active {\n    color: #667eea;\n    border-bottom-color: #667eea;\n}\n\n.dashboard-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px;\n}\n\n.dashboard-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.dashboard-actions h2 {\n    margin: 0;\n    color: #333;\n}\n\n.primary-btn {\n    padding: 10px 20px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    width: auto;\n}\n\n.primary-btn:hover {\n    background: #5568d3;\n}\n\n.error {\n    background: #fee;\n    color: #c33;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.loading {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
